<template>
<div class="card">
  <div class="card-body help-card-body">
    <div class="text-center">
      <h4>Skills</h4>
    </div>
    <hr>
    <p>This section has one primary purpose: to <b>motivate the employer to read the rest of the r&egrave;sum&egrave;.</b></p>
    <p>Everyone has innate skills that will lead you towards specific career paths. The trick is to identify and strengthen them.</p>
    <p>Your challenge now is to consider this mass of skills and decide which personality characteristics to present to prospective employers</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'skills',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
